module.exports = __webpack_public_path__ + "static/img/max_pictgrid15_960x858.75bce7e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/max_pictgrid15_960x858.jpg
// module id = /iD5
// module chunks = 0